import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import PropTypes from 'prop-types';
import compose from 'recompose/compose';


const styles = (_theme) => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    position: 'relative',
  },
  inputField: {
    background: 'transparent',
    maxWidth: '100%',
    outline: 'none',
    border: 'none',
    minWidth: 20,
    flexGrow: 1,
    padding: '5px 2px 6px 2px',
    fontSize: 14,
    minHeight: 26,
  },
  placeholder: {
    minHeight: 26,
    left: 0,
    outline: 'none',
    border: 'none',
    color: 'black',
    opacity: '100%',
    fontSize: 14,
    padding: '9px 2px 6px 2px',
    position: 'absolute',
  },
});

class TagsField extends React.PureComponent {

  constructor(props) {
    super(props);
    this.spanRef = React.createRef();
    this.state = {
      value: '',
      hoverDelete: false,
    };
  }

  componentDidMount() {
    if (this.props.autoFocus) {
      this.spanRef.focus();
    }
    this.spanRef.addEventListener('DOMSubtreeModified', this.handleChange);
  }

  componentWillUnmount() {
    this.spanRef.removeEventListener('DOMSubtreeModified', this.handleChange);
  }

  cleanValue = () => {
    if (this.spanRef)
      this.spanRef.innerHTML = '';
  };

  handleChange = (_event) => {
    if (this.props.maxLength && this.spanRef.innerText.length > this.props.maxLength) {
      this.spanRef.innerText = this.state.value;
    } else {
      this.setState({ value: this.spanRef.innerText });
      this.props.onChange(this.spanRef.innerText);
    }
  };

  handleFocus = (_event) => {
    this.setState({ hoverDelete: false });
    if (this.spanRef)
      this.spanRef.focus();
    if (this.props.keyDelete)
      this.props.onHoverDelete(false);
  };

  handleKeyDown = (event) => {
    if (event.key === 'Backspace' && this.state.value === '' && this.props.keyDelete && !this.state.hoverDelete) {
      this.setState({ hoverDelete: true });
      this.props.onHoverDelete(true);
    } else if (event.key === 'Backspace' && this.props.keyDelete && this.state.hoverDelete) {
      this.props.onDelete();
    } else if (event.key === 'Enter') {
      // solves a race condition with the menu selecting an item
      setTimeout(() => {
        if (this.spanRef)
          this.spanRef.innerHTML = ''
      }, 100);
    } else if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
      // validation to avoid ArrowDown/ArrowUp, it affects the nestedQMenu event listener, thus setState fails there
      this.setState({ hoverDelete: false });
      this.props.onHoverDelete(false);
    }
  };

  render() {

    const { classes, chips, placeholder, getInputProps, bulkEdit } = this.props;
    const { value } = this.state;

    // Send clean value method to parent to be called inside the menu close action
    getInputProps && getInputProps({
      cleanValue: this.cleanValue,
    });

    return (
      <div
        className={classes.root}
      >
        {chips.map((chip) => chip)}
        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
        <span
          type="text"
          onKeyDown={this.handleKeyDown}
          onFocus={this.handleFocus}
          className={classes.inputField}
          ref={(node) => {
            if (this.props.inputRef)
              this.props.inputRef(node);
            this.spanRef = node;
          }}
          contentEditable
        />
        {placeholder && value === '' && (chips.length === 0 || chips.size === 0) &&
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <span onClick={this.handleFocus} className={classes.placeholder} style={!bulkEdit ? {color: '#999'} : {}}>
            {placeholder}
          </span>
        }
      </div>
    );
  }
}

TagsField.propTypes = {
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  chips: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  inputRef: PropTypes.func,
  getInputProps: PropTypes.func,
  keyDelete: PropTypes.bool,
  onHoverDelete: PropTypes.func,
  onDelete: PropTypes.func,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  autoFocus: PropTypes.bool,
  bulkEdit: PropTypes.bool,
};

// These are prop injectors
export default compose(
  withStyles(styles),  // creates this.props.classes
)(TagsField);

